import CareerPage from "../../components/Career/CareerPage";

const CareerContainer = () => {
  return <CareerPage />;
};

export default CareerContainer;
